export default {
  title: 'Uusi brändi',
  tabs: {
    general: 'Yleiset',
    branding: 'Brändäys',
    scripts: 'Skriptit',
    tracking: 'Seuranta',
    domain: 'Verkkotunnus',
  },
  fields: {
    name: {
      label: 'Nimi',
      placeholder: 'Brändin nimi',
    },
    slug: {
      label: 'Alitunnus',
      placeholder: 'Brändin alitunnus',
      hint: 'Pienet kirjaimet, numerot ja yhdysmerkit. Yhdessä kaupan verkkotunnuksen kanssa se muodostaa kaupan osoitteen.',
      preview: 'Kaupan osoite: {{url}}',
      availability: {
        taken: 'Toinen brändi käyttää jo tätä alitunnusta tällä kaupan verkkotunnuksella.',
        reserved: 'Tämä alitunnus on varattu. Valitse toinen.',
        invalid_label:
          'Tällä kaupan verkkotunnuksella alitunnus voi sisältää vain pieniä kirjaimia, numeroita ja yhdysmerkkejä, sen täytyy alkaa ja päättyä kirjaimeen tai numeroon, ja se voi olla enintään 63 merkkiä pitkä.',
        taken_elsewhere: 'Toisella kaupan verkkotunnuksella oleva brändi käyttää jo tätä alitunnusta. Valitse toinen.',
        format: 'Käytä vain kirjaimia, numeroita, yhdysmerkkejä ja alaviivoja.',
        unavailable: 'Tämä alitunnus ei ole käytettävissä. Valitse toinen.',
      },
    },
    shop_domain_id: {
      label: 'Kaupan verkkotunnus',
      placeholder: 'Valitse kaupan verkkotunnus',
      move_warning: {
        title: 'Tämä muuttaa asiakkaiden käyttämää kaupan osoitetta',
        description:
          'Tallennuksen jälkeen kauppa on osoitteessa {{url}}. Jo tulostetut tai jaetut QR-koodit, mainoslehtiset ja linkit lakkaavat toimimasta.',
      },
    },
    lieferando_url: {
      label: 'Lieferando-URL',
      placeholder: 'Ravintolan URL Lieferandossa',
    },
    primary_color: {
      label: 'Pääväri',
    },
    logo: {
      label: 'Logo',
    },
    image: {
      label: 'Kuva',
    },
    companies: {
      label: 'Ravintolat',
    },
    noscripts: {
      description: 'Lisää koodi heti body-tagin avaamisen jälkeen',
    },
    facebook_pixel: {
      label: 'Facebook Pixel',
    },
    facebook_conversion_api_access_token: {
      label: 'Facebookin konversioiden käyttöoikeustunnus',
    },
    google_analytics_id: {
      label: 'Google Analytics -tunnus',
    },
    google_ads_conversion_label_id: {
      label: 'Google Ads -konversiotunniste',
    },
    // Named in the modal's error summary when the domain is refused.
    online_shop_domain: {
      label: 'Oma verkkotunnus verkkokauppaa varten',
    },
  },
  buttons: {
    save: 'Tallenna',
    close: 'Sulje',
    sync_from_lieferando: 'Synkronoi Lieferandosta',
  },
  toasts: {
    changes_saved_successfully: 'Muutokset tallennettu onnistuneesti!',
    failed_to_update_company_slug: 'Brändin {{name}} alitunnuksen päivitys epäonnistui',
    failed_to_sync_lieferando: 'Tietojen synkronointi Lieferandosta epäonnistui',
    successfully_synced_lieferando: 'Tiedot synkronoitu onnistuneesti Lieferandosta',
    failed_to_load_shop_domains: 'Kaupan verkkotunnuksia ei voitu ladata.',
    logo_file_too_large: 'Logo on liian suuri. Enimmäiskoko on {{max}} Mt.',
    logo_dimensions_too_large: 'Logo on liian suuri. Leveys ja korkeus saavat olla enintään {{max}} pikseliä.',
  },
};
